import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { IoSearchOutline } from "react-icons/io5";
import Grid, {
  GridColumn,
  GridHeader,
  GridRow,
} from "../../components/Grid/Grid";
import ShareService from "../../Services/ShareService";
import WebService from "../../Services/WebService";
import GroupDeleteModal from "../../components/LessonDeleteModal/LessonDeleteModal";
import Loader from "../../components/Loader/Loader";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"; // ✅ drag & drop
import { toast } from "react-toastify";
import { BiArrowBack } from "react-icons/bi";

const CourseLessons: React.FC = () => {
  const [rows, setRows] = useState<GridRow[]>([]);
  const [lessonList, setLessonList] = useState<any[]>([]); 
  const [ShowLoader, setShowLoader] = useState(false);
  const [FilterObj, setFilterObj] = useState<any>({});
  const [Count, setCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [request, setRequest] = useState<any>("");
  const [searchKeyword, setSearchKeyword] = useState(""); 
  const item = useParams();
  const location = useLocation();
const [pageTitle, setPageTitle] = useState("");

  const title = location.state?.title; 

  useEffect(() => {
  if (location.state?.title) {
    setPageTitle(location.state.title);
  } else {
    // fallback API call
    // WebService.getAPI({
    //   action: `/course-level/${item.id}`,
    // }).then((res: any) => {
    //   setPageTitle(res?.name || "");
    // });
  }
}, []);

  useEffect(() => {
    const prevFilter: any = ShareService.getMapValue("listing-lessons-filter");
    if (prevFilter) {
      setFilterObj(prevFilter);
      setSearchKeyword(prevFilter.keyword || "");
      getlist(
        prevFilter.offset ? prevFilter.offset + 1 : 1,
        prevFilter.keyword,
        prevFilter.order_by,
        prevFilter.sort_by
      );
    } else {
      getlist(1);
      console.log(title);
    }
  }, []);

  const onchange = (currentPage: number, searchText?: string) => {
    let obj: any = { ...FilterObj };
    obj.offset = currentPage ? currentPage - 1 : 0;
    obj.keyword = searchText !== undefined ? searchText : searchKeyword;
    ShareService.setMapValue("listing-lessons-filter", obj);
    setFilterObj(obj);
    getlist(currentPage, obj.keyword);
  };

  const onSort = (sortKey: string, order: string, sort_by: any) => {
    const obj: any = { ...FilterObj };
    const orderBy = order ? "asc" : "desc";
    obj.sort_by = sort_by;
    obj.order_by = orderBy;
    ShareService.setMapValue("listing-lessons-filter", obj);
    setFilterObj(obj);
    getlist(1, obj.keyword, orderBy, sort_by);
  };

  const getlist = (
    page: number,
    searchText?: string,
    order_by?: string,
    sort_by?: string
  ) => {
    setShowLoader(true);
    const obj: any = { ...FilterObj };
    obj.offset = page ? page - 1 : 0;
    obj.keyword = searchText ?? "";
    if (order_by) obj.order_by = order_by;
    if (sort_by) obj.sort_by = sort_by;

    setFilterObj(obj);
    ShareService.setMapValue("listing-lessons-filter", obj);

    const queryParams = new URLSearchParams({
      course_level_id: item.id || "",
      keyword: obj.keyword || "",
      sort_by: obj.sort_by || "",
      order_by: obj.order_by || "",
      offset: obj.offset.toString(),
      limit: "50", // ✅ bigger limit for drag ordering
    }).toString();

    WebService.getAPI({ action: `/lessons/list?${queryParams}` })
      .then((res: any) => {
        setShowLoader(false);
        setCount(res.count);
        setLessonList(res.list || []); // ✅ for drag
        const rows: GridRow[] = res.list.map((lesson: any, i: number) => ({
          data: [
            { value: obj.offset === 0 ? i + 1 : 10 * obj.offset + i + 1 },
            { value: lesson.name },
            { value: Questions(lesson) },
            { value: actionList(lesson) },
          ],
        }));
        setRows(rows);
      })
      .catch(() => setShowLoader(false));
  };

  const handleDelete = (id: any) => {
    setShowModal(true);
    setRequest(id);
  };

  const Questions = (lesson: any) => {
    const activeId = lesson.active_lesson_questions_version_id;
    const draftId = lesson.draft_lesson_questions_version_id;
    const lessonUuid = lesson.uuid;
    const smallBtnStyle: React.CSSProperties = {
      padding: "2px 8px",
      fontSize: "12px",
      lineHeight: 1.2,
    };

    const btn = (label: string, href: string, cls: string) => (
      <Link
        to={href}
        className={`btn btn-sm ${cls} me-1`}
        style={smallBtnStyle}
        title={label}
      >
        {label}
      </Link>
    );

    return (
      <div className="d-flex align-items-center flex-wrap gap-1">
        {activeId
          ? btn(
              "View Published Version",
              `/questions?uuid=${lessonUuid}&version=published`,
              "btn-success"
            )
          : null}
        {draftId
          ? btn(
              "View Drafted Version",
              `/questions?uuid=${lessonUuid}&version=draft`,
              "btn-warning text-dark"
            )
          : null}
        {!activeId && !draftId
          ? btn(
              "Add Question",
              `/questions?uuid=${lessonUuid}&version=draft`,
              "btn-primary"
            )
          : null}
      </div>
    );
  };

  const actionList = (data: any) => {
    return (
      <div className="action-btns text-left">
        <Link
          to={`/lesson/edit/${item.id}/${data.uuid}`}
          className="text-dark p-1 me-1"
          title="Edit"
        >
          <FiEdit size={18} />
        </Link>
        <a
          className="text-danger p-1"
          title="Delete"
          onClick={() => handleDelete(data.uuid)}
        >
          <FiTrash2 size={18} />
        </a>
      </div>
    );
  };

  // ✅ Drag-and-drop reorder logic
  const handleDragEnd = async (result: any) => {
    if (!result.destination) return;
    const reordered = Array.from(lessonList);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setLessonList(reordered);

    try {
      const payload = reordered.map((x, i) => ({
        uuid: x.uuid,
        ordering: i + 1,
      }));
      await WebService.postAPI({
        action: "/lessons/reorder",
        body: { order: payload },
      });
      toast.success("Lesson order updated successfully");
      getlist(1, searchKeyword);
    } catch (err) {
      toast.error("Failed to update order");
    }
  };

  const headers: GridHeader[] = [
    { title: "Sr No", class: "text-center" },
    {
      title: "Lesson Title",
      class: "text-center",
      isSorting: true,
      sortingKey: "name",
    },
    {
      title: "Questions",
      class: "text-center",
    },
    { title: "Action", class: "text-center" },
  ];
  const [gridHeader] = useState<GridHeader[]>(headers);

  return (
    <div className="dashboard-content">
      <Row className="mb-2 align-items-center">
        <Col className="d-flex align-items-center gap-2">
          <Link
            to={`/course-levels`}
            className="d-flex align-items-center text-decoration-none text-dark"
          >
            <BiArrowBack size={20} className="me-1 mx-2" />
            <span>Back</span>
          </Link>


          <h1 className="font-20 font-bold mb-0">{title}</h1>
        </Col>
      </Row>

      <Row className="mb-3 align-items-center justify-content-between">
        <Col lg={7}>
          <h3 className="font-20 font-bold mb-0">Manage Lessons</h3>
        </Col>
        <Col lg={3} className="d-flex justify-content-end">
          <InputGroup className="table-search-bar me-3 rounded-1">
            <InputGroup.Text>
              <IoSearchOutline size={18} />
            </InputGroup.Text>
            <Form.Control
              id="listing-lesson-search"
              placeholder="Search..."
              value={searchKeyword}
              onChange={(e: any) => setSearchKeyword(e.target.value)}
              onKeyUp={(e: any) => getlist(1, e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col lg={2}>
          <Link to={`/lesson/${item.id}/add`} className="text-decoration-none">
            <button className="btn btn-brand-1 d-block mx-auto">
              + Course Lesson
            </button>
          </Link>
        </Col>
      </Row>

      <Loader show={ShowLoader} />

      {/* ✅ Table with Drag-and-drop rows */}
      <div
        className="p-2 card"
        style={{ marginBottom: 70, height: "100vh", overflowY: "auto" }}
      >
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th style={{ width: "60px" }}>#</th>
              <th>Lesson Title</th>
              <th>Questions</th>
              <th>Action</th>
            </tr>
          </thead>

          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="lessons">
              {(provided) => (
                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                  {lessonList.map((lesson, index) => (
                    <Draggable
                      key={lesson.uuid}
                      draggableId={lesson.uuid}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={snapshot.isDragging ? "table-active" : ""}
                          style={{
                            ...provided.draggableProps.style,
                            cursor: "grab",
                          }}
                        >
                          <td>{index + 1}</td>
                          <td>{lesson.name}</td>
                          <td>{Questions(lesson)}</td>
                          <td>{actionList(lesson)}</td>
                        </tr>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>
      </div>

      {showModal && (
        <GroupDeleteModal
          id={request}
          title="Are you sure you want to delete!"
          showModal={showModal}
          onCloseModel={() => {
            setShowModal(false);
            getlist(1, searchKeyword);
          }}
        />
      )}
    </div>
  );
};
export default CourseLessons;
